/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable no-param-reassign */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { List, fromJS } from 'immutable';
import { CANDIDATE_ID } from 'constants/users';
import { MOTIVATOR_SURVEY_ANSWER_URL } from 'constants/api';
import { PRE_ENGAGEMENT } from 'constants/pageDictionary';
import max from 'lodash/max';
import PageProgress from '../../components/page-progress/PageProgress';
import NavigateButton from '../../components/navigate-buttons/NavigateButton';
import * as pageActions from '../../actions/pageActions';
import * as surveyActions from '../../actions/surveyActions';
import Radio from './Radio';
import './Motivator.scss';

const checkedColor = '#9DC3CC';
const unCheckedColor = '#FFFFFF';
const MAX_OPTION = 5;
const MIN_OPTION = 0;
const pages = [];

class Motivator extends Component {
    constructor(props) {
        super(props);
        const result = [];
        const questionList = props.surveyQuestion.get('likert').toJS();
        for (let i = 0; i < questionList.length - 1; i += 2) {
            pages.push([
                {
                    'statement': questionList[i].title,
                    'id': questionList[i].id
                },
                {
                    'statement': questionList[i + 1].title,
                    'id': questionList[i + 1].id
                }
            ]);

            if (result.length === Math.floor(i / 2) && questionList[i].optionId >= 0) {
                const optionA = questionList[i].optionId;
                const optionB = questionList[i + 1].optionId;
                const option = (3 - optionA) + max([
                    optionB - 1, 0
                ]);
                result.push(option);
            }
        }
        this.state = {
            questionList,
            currentQuestionIndex: result.length,
            answerAll: result.length === questionList.length,
            loading: false,
            hiddenError: false,
            result: new List(result)
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        const {
            currentQuestionIndex, loading, result, mouseDown, hiddenError
        } = this.state;
        const { error } = this.props;
        const answerOptions = this.options();
        return (
            <div
                tabIndex='1'
                className='container-fluid fl-sv-survey-try-wrapper no-select fl-motivator'
                onKeyDown={ this.handleKeyPress }>
                { currentQuestionIndex < pages.length && <div className='fl-sv-survey-likert-motivator'>
                    <PageProgress
                        pageNumber={ pages.length }
                        currentPageNumber={ currentQuestionIndex + 1 } />
                    <div className='fl-likert-question'>
                        <div className='fl-likert-question-title'>
                            { i18n.t('motivator.please_indicate_which_of_the_two_statements') }
                        </div>
                        <div
                            onMouseMove={ this.handleMouseMove }
                            onMouseUp={ this.handleMouseUp }
                            className={ `fl-likert-question-answer ${ mouseDown ? 'fl-mousedown' : '' }` }>
                            <div
                                className='fl-bar'
                                style={ { display: 'flex', alignItems: 'center' } }
                                ref={ (t) => this.bar = t }>
                                { answerOptions }
                            </div>
                            <div
                                ref={ (d) => this.dot = d }
                                className='default-dot'
                                onMouseDown={ this.handleMouseDown }
                                onTouchStart={ this.handleMouseDown }
                                onTouchMove={ this.handleMouseMove }
                                onTouchEnd={ this.handleMouseUp }>
                                { result.size === currentQuestionIndex && <div className='option-control fl-tooltip'>
                                    <i className='fa fa-arrow-left' onClick={ () => this.onSelectAnswer(2) } />
                                    <i className='fa fa-arrow-right' onClick={ () => this.onSelectAnswer(3) } />
                                </div> }
                            </div>
                        </div>
                        <div className='fl-likert-question-statement'>
                            <div
                                className='text-right'
                                style={ {
                                    color: result.get(currentQuestionIndex) > 2 ? 'rgba(30, 60, 77, 0.4)' : 'rgba(30, 60, 77, 1)'
                                } }>{ pages[currentQuestionIndex][0].statement }</div>
                            <div
                                style={ {
                                    color: result.get(currentQuestionIndex) <= 2 ? 'rgba(30, 60, 77, 0.4)' : 'rgba(30, 60, 77, 1)'
                                } }>
                                { pages[currentQuestionIndex][1].statement }
                            </div>
                        </div>
                        <div className='fl-error'>{ error && !hiddenError && 'Sorry, an error has occured, please try again.' }</div>
                        <div className='fl-likert-btn'>
                            <NavigateButton
                                onBack={ this.onBack }
                                backTitle={ i18n.t('motivator.back') }
                                disableBack={ currentQuestionIndex === 0 || loading }
                                disableNext={ result.get(currentQuestionIndex) === undefined
                                || loading }
                                nextTitle={ currentQuestionIndex + 1 < pages.length ? i18n.t('motivator.next') : i18n.t('motivator.finish') }
                                onContinue={ this.nextPage } />
                        </div>
                    </div>
                </div> }
            </div>
        );
    }

    onBack = () => {
        window.scrollTo(0, 0);
        const { currentQuestionIndex, result } = this.state;
        this.setState({ currentQuestionIndex: currentQuestionIndex - 1 });

        this.dot.style.background = checkedColor;
        this.setDotPosition(result.get(currentQuestionIndex - 1));
    };

    onSelectAnswer = (answerIndex, moveDot = true) => {
        const { currentQuestionIndex, result } = this.state;
        this.dot.style.background = checkedColor;
        if (answerIndex > MAX_OPTION) {
            answerIndex = MAX_OPTION;
        } else if (answerIndex < MIN_OPTION) {
            answerIndex = MIN_OPTION;
        }
        if (result.size === currentQuestionIndex) {
            this.setState({ result: result.push(answerIndex), hiddenError: true });
        } else {
            this.setState({
                result: result.update(currentQuestionIndex, () => answerIndex),
                hiddenError: true
            });
        }

        if (moveDot) {
            this.setDotPosition(answerIndex);
        }
    };

    onSubmit = () => {
        const { respondentInfo } = this.props;
        this.sendAnswer(true)
            .then((res) => {
                if (res === false) {
                    throw Error();
                }
                // ATTUNED-3090
                if (respondentInfo.get('respondentRoleId') === CANDIDATE_ID || !res.pending_engagement_survey_id || respondentInfo.get('has_engagement_module') !== true) {
                    const path = window.location.pathname.split('/');
                    const motivatorToken = path[path.length - 1];

                    window.location.href = `${ process.env.ATTUNED_URL }/report/motivator/${ motivatorToken }?newuser=true`;
                } else {
                    this.props.actions.goToPage(PRE_ENGAGEMENT);
                }
            })
            .catch(() => {
                this.setState({ loading: false, hiddenError: true });
            });
    };

    onNextPage = () => {
        const { result, currentQuestionIndex } = this.state;
        this.sendAnswer()
            .then((res) => {
                if (res === false) {
                    throw Error();
                }
                this.setState({ currentQuestionIndex: currentQuestionIndex + 1, loading: false });
                if (result.size - 1 === currentQuestionIndex) {
                    this.dot.style.background = unCheckedColor;
                    this.setDotPosition(2.5);
                } else {
                    this.dot.style.background = checkedColor;
                    this.setDotPosition(result.get(currentQuestionIndex + 1));
                }
            })
            .catch(() => {
                this.setState({ loading: false, hiddenError: false });
            });
    };

    sendAnswer = (isSubmit = false) => {
        const { result, questionList, currentQuestionIndex } = this.state;
        const option = result.get(currentQuestionIndex);
        const optionA = max([
            3 - option, 0
        ]);
        const optionB = optionA > 0 ? 0 : option - 2;
        const questionA = {
            id: questionList[currentQuestionIndex * 2].id,
            type: 'likert',
            optionId: optionA
        };
        const questionB = {
            id: questionList[(currentQuestionIndex * 2) + 1].id,
            type: 'likert',
            optionId: optionB
        };
        const newResult = fromJS([
            questionA, questionB
        ]);
        this.setState({ loading: true });
        return this.props.actions.autoSave({
            survey: newResult, isSubmit, surveyId: 4, type: MOTIVATOR_SURVEY_ANSWER_URL
        });
    };

    nextPage = () => {
        window.scrollTo(0, 0);
        const { currentQuestionIndex, result } = this.state;
        if (result.get(currentQuestionIndex) !== undefined) {
            if (currentQuestionIndex === pages.length - 1) {
                this.onSubmit();
            } else {
                this.onNextPage();
            }
        }
    };

    options = () => {
        const answers = [
            i18n.t('motivator.strongly_prefer'), i18n.t('motivator.prefer'), i18n.t('motivator.somewhat_prefer'), i18n.t('motivator.somewhat_prefer'), i18n.t('motivator.prefer'), i18n.t('motivator.strongly_prefer')
        ];
        const {
            currentQuestionIndex, loading, answerAll, result
        } = this.state;
        return answers.map((item, index) =>
            (<Radio
                className={ i18n.language === '日本語' ? 'fl-likert-answer-option jp-language' : 'fl-likert-answer-option english-language' }
                key={ `${ currentQuestionIndex }-${ index }` }
                name='answer'
                checked={ result.get(currentQuestionIndex) === index }
                disabled={ loading || answerAll }
                onChange={ () => this.onSelectAnswer(index) }
                text={ item } />));
    };

    handleMouseDown = (e) => {
        e.stopPropagation();
        this.left = this.bar.getBoundingClientRect().left;
        this.right = this.bar.getBoundingClientRect().right;
        this.setState({ mouseDown: true });
        this.down = true;
        this.lastX = (e.clientX || e.touches[0].clientX) - this.left;
    };

    handleMouseMove = (e) => {
        e.stopPropagation();
        if (this.down) {
            const left = (e.clientX || e.touches[0].clientX) - this.left;
            const barWidth = this.right - this.left;
            const start = barWidth * 0.08;
            const end = barWidth * 0.91;
            if (left > start && left < end) {
                this.dot.style.left = `${ left }px`;
            }

            this.lastX = left;
        }
    };

    handleMouseUp = (e) => {
        e.stopPropagation();

        if (this.down) {
            const left = this.lastX;
            const barWidth = this.right - this.left;
            const start = barWidth * 0.08;
            const distance = barWidth * 0.166;
            const option = Math.round((left - start) / distance);
            this.onSelectAnswer(option);
        }

        this.down = false;
        this.setState({ mouseDown: false });
    };

    handleKeyPress = (e) => {
        if (e.which === 13) {
            this.nextPage();
        }
    };

    setDotPosition = (index) => {
        this.left = this.bar.getBoundingClientRect().left;
        this.right = this.bar.getBoundingClientRect().right;
        const barWidth = (this.right - this.left) - 2;
        const start = barWidth * 0.08;
        const distance = barWidth * 0.166;
        const left = (index * distance) + (start + 2);
        this.dot.style.left = `${ left }px`;
    };
}

Motivator.propTypes = {
    actions: PropTypes.object,
    surveyQuestion: PropTypes.object,
    respondentInfo: PropTypes.object,
    error: PropTypes.string
};

Motivator.defaultProps = {
    actions: null,
    respondentInfo: null,
    surveyQuestion: null,
    error: ''
};

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(Object.assign({}, pageActions, surveyActions), dispatch)
});

const mapStateToProps = (state) => ({
    surveyQuestion: state.surveyReducer,
    error: state.autoSaveReducer.get('error'),
    respondentInfo: state.respondentNameReducer
});

export default connect(mapStateToProps, mapDispatchToProps)(Motivator);
